import { createContext } from "react";

export interface IComponentsContext {
  MuxSpinner: any;
  SearchBox: any;
  DropdownMenuItem: any;
  DropdownMenu: any;
  DropdownMenuBody: any;
  Select2: any;
}

export const ComponentsContext = createContext<IComponentsContext>({
  MuxSpinner: null,
  SearchBox: null,
  DropdownMenu: null,
  DropdownMenuItem: null,
  DropdownMenuBody: null,
  Select2: null,
});

export const ComponentsProvider = ComponentsContext.Provider;
